import { defineStore } from "pinia"

import {
  gettersCartProducts,
  persistOptionsCartProducts,
  actionsCartProducts,
  stateCartProducts,
} from "@academy/components"

export const useCartProducts = defineStore("cart-products", {
  state: () => stateCartProducts,
  getters: gettersCartProducts,
  actions: actionsCartProducts,
  ...persistOptionsCartProducts,
})
